var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('role-form',{attrs:{"loading":_vm.loading,"roleData":_vm.role,"formErrors":_vm.formErrors},on:{"roleSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }